import './components/menu.js';
import './components/sliders.js';
import './components/mixit.js';
import './components/filter.js';
import './components/accordion.js';
import './components/select.js';